import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import { StandaloneModule } from './standalone.module';
import { WorkspaceComponent } from '../components/ehr/workspace/workspace.component';
import { IncomingReferralsComponent } from '../components/ehr/workspace/incoming-referrals/incoming-referrals.component';
import { MyPatientsComponent } from '../components/ehr/workspace/my-patients/my-patients.component';

@NgModule({
  declarations: [
    WorkspaceComponent,
    IncomingReferralsComponent,
    MyPatientsComponent,
  ],
  imports: [SharedModule, StandaloneModule],
  exports: [
    WorkspaceComponent,
    IncomingReferralsComponent,
    MyPatientsComponent,
  ],
})
export class WorkspaceModule {}
